import { Application } from 't3js';
import cookies from '@buzzfeed/buzzblocks/js/services/cookies';

/**
 * Handles interaction and state storage for the bounce policy
 * (the bar that appears in the top of the site)
 *
 * This is 'visible unless the user hides' (I.e. it'll show
 * without JavaScript enabled and is therefore opt-out to hide)
 */
class BouncePolicy {
  /**
   * @constructor
   * @param context
   */
  constructor(context) {
    this._element = context.getElement();
    this._bouncePolicyCookie = 'bounce_policy_closed';

    if (!this.getIsClosed()) {
      this._element.classList.remove('js-hidden');
    }
  }

  /**
   * Finds out if this has been closed already
   * @returns bool
   */
  getIsClosed() {
    return !!cookies.get(this._bouncePolicyCookie, false);
  }

  /**
   * Sets the isClosed state on a cookie for a year
   */
  setIsClosed(isClosed) {
    if (isClosed) {
      cookies.set({
        name: this._bouncePolicyCookie,
        value: 'opt-out',
        days: 365,
        domain: window.location.hostname
      });
    } else {
      cookies.remove(this._bouncePolicyCookie, window.location.hostname);
    }
  }

  /**
   * Triggers UI animation to close
   */
  closeAnimated() {
    this._element.classList.add('bounce-policy--animation');
    setTimeout(() => this._element.classList.add('js-hidden'), 1000);
  }

  /**
   * Handles the on-click behavior
   */
  onclick(e, elem, elemType) {
    if (elemType === 'bounce-close') {
      e.preventDefault();
      this.setIsClosed(true);
      this.closeAnimated();
    }
    return false;
  }
}

Application.addModule('bounce-policy', (context) => {
  return new BouncePolicy(context);
});



// WEBPACK FOOTER //
// /app/static/js/modules/bounce-policy.js